import { render, staticRenderFns } from "./treasureContractRentModals.vue?vue&type=template&id=06d24c43&scoped=true&"
import script from "./treasureContractRentModals.vue?vue&type=script&lang=js&"
export * from "./treasureContractRentModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d24c43",
  null
  
)

export default component.exports